import { render, staticRenderFns } from "./OvyPAYNetworkForm.vue?vue&type=template&id=3852af2e&scoped=true"
import script from "./OvyPAYNetworkForm.vue?vue&type=script&lang=js"
export * from "./OvyPAYNetworkForm.vue?vue&type=script&lang=js"
import style0 from "./OvyPAYNetworkForm.vue?vue&type=style&index=0&id=3852af2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852af2e",
  null
  
)

export default component.exports